export const endpoints = {
  MITCO_API_URL: process.env.REACT_APP_API_URL,
  WORKSPACE_PERMS: "/v1/users/workspace_perms/",
};
